import React from 'react';

type TableColumnProps = {
  value: any;
};

const TableColumn = ({ value }: TableColumnProps): JSX.Element => <span title={value}>{value}</span>;

export default TableColumn;
